import { useState } from 'react';
import { sharingSteps } from './ProjectSharing';
import { ProjectSharingHeader } from './ProjectSharingHeader';
import { triggerFileDownload } from '../../utils';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './project-sharing.module.less';
import { ProjectSharingFooter } from './ProjectSharingFooter';
import { MarkAsCompleteButton } from './ProjectSharingMarkAsComplete';
import { connect, useSelector } from 'react-redux';
import Spinner from '../../components/spinner/Spinner';
import VisibleIf from '../../components/VisibleIf';
import { Link } from 'react-router';
import Image from '../../components/image/Image';
import ShareInProjectButton from '../share/ShareInProjectButton';
import { getUserAgent } from '../../utils/browserDetector';

const ProjectSharingInstagram = ({ setSharingStepComplete, project, completed, showStreamLabs }) => {
    const footerBackLink = `/project/${project.id}/sharing/4`;
    const footerBackLinkText = 'Grupper og fellesskap';
    const footerForwardLink = `/project/${project.id}/sharing/${showStreamLabs ? 6 : ''}`;
    const footerForwardLinkText = showStreamLabs ? 'Streaming' : 'Oppsummering';
    const [loading, setLoading] = useState(true);
    const baseURL = useSelector((state) => state.baseURL);

    const fullImageUrl = `${baseURL}/api/public/project/${project.id}/shareImage`;
    const imageViewer = project.img_url ? (
        <>
            <div className={styles.instagramWrapper}>
                <VisibleIf isVisible={loading}>
                    <Spinner size="300px" borderWidth="10px" className={styles.spinner} />
                </VisibleIf>
                <Image
                    className={styles.instagramPhoto}
                    src={`/api/public/project/${project.id}/shareImage`}
                    title={'Last ned og del på Instagram'}
                    alt={'Delingsbilde til Instagram'}
                    onLoad={() => setLoading(false)}
                />
                <ShareInProjectButton
                    label="Del bildet"
                    faIcon="fab fa-instagram"
                    urlToImageToShare={fullImageUrl}
                    buttonClassName={styles.nativeShareButton}
                    onClickFallback={() => {
                        trackEvent('admin', 'project-share', {
                            channel: 'instagram',
                            activity: 'instagram',
                            'project-id': project.id,
                        });
                        triggerFileDownload(fullImageUrl, `${project.title.replaceAll(' ', '_')}`);
                    }}
                    trackEventFunction={() =>
                        trackEvent('admin', 'project-share', {
                            channel: 'instagram',
                            activity: 'instagram',
                            'project-id': project.id,
                        })
                    }
                />
            </div>
            <p>Del bildet på Instagram som et vanlig innlegg eller i story.</p>
        </>
    ) : (
        <p className={styles.noInstagramPhoto}>
            Du mangler bilde på innsamlingen din. Legg til et toppbilde på{' '}
            <Link to={`/project/${project.id}`}>spleisen ditt</Link> for å kunne dele det på Instagram.
        </p>
    );

    return (
        <>
            <ProjectSharingHeader
                title="Del på Instagram"
                backLink={`/project/${project.id}/sharing`}
                backLinkText="Tilbake til delingspanelet"
            />
            <section className={styles.contentPanel}>
                <ul className={styles.checkmarkList}>
                    <li>Instagram er plattformen med mest engasjerte brukere</li>
                    <li>Husk hashtags for å få enda flere til å oppdage innsamlingen din</li>
                </ul>
                {imageViewer}

                <MarkAsCompleteButton
                    completed={completed}
                    onClick={() => {
                        setSharingStepComplete(sharingSteps.instagram);
                        trackEvent('shareguide', 'step-complete', {
                            activity: 'instagram',
                            'project-id': project.id,
                        });
                    }}
                />
            </section>
            <ProjectSharingFooter
                backLink={footerBackLink}
                backLinkText={footerBackLinkText}
                forwardLink={footerForwardLink}
                forwardLinkText={footerForwardLinkText}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userAgent: getUserAgent(state),
    };
};

export default connect(mapStateToProps)(ProjectSharingInstagram);
